import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TreeViewPage } from '../tree-view/TreeViewPage';
import { TreeEdit } from '../editor/TreeEdit';
import { RedirectToDefaultTree } from './RedirectToDefaultTree';
import { AboutPage } from './AboutPage';
import { MyTreesPage } from '../my-trees/MyTreesPage';
import { NotFoundPage } from './NotFoundPage';
import { VersionRefreshBanner } from '../version/VersionRefreshBanner';

export const App: React.FC = () => {
    return (
        <>
            <Analytics />
            <VersionRefreshBanner />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<RedirectToDefaultTree />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/trees" element={<MyTreesPage />} />
                    <Route path="/tree/:treeId/edit" element={<TreeEdit />} />
                    <Route path="/tree/:treeId/:nodeId" element={<TreeViewPage />} />
                    <Route path="/tree/:treeId" element={<TreeViewPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </BrowserRouter>
        </>
    );
};
